import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { messagesApi } from "../../../features/messages/messagesApi";
import Message from "./Message";

export default function Messages({ messages = [], totalCount, id }) {
    const { user } = useSelector((state) => state.auth) || {};
    const { email } = user || {};
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();

    const hasMore = Math.ceil(totalCount / process.env.REACT_APP_MESSAGES_PER_PAGE) > page
    console.log("file: Messages.js ~ line 14 ~ Messages ~ hasMore", { hasMore, totalCount, page })

    const fetchMore = () => {
        setPage(currentPage => {
            return currentPage + 1;
        })
        console.log("fetching");
    }

    useEffect(() => {
        if (page > 1) {
            dispatch(messagesApi.endpoints.getMoreMessages.initiate({ id, page }))
        }
    },
        //eslint-disable-next-line
        [page]);

    useEffect(() => {
        if (messages?.length === 0) {
            setPage(1)
        }
        setPage(Math.ceil(messages?.length / process.env.REACT_APP_MESSAGES_PER_PAGE))
    }, [id, messages])



    return (
        <div className="relative w-full h-[calc(100vh_-_197px)] p-6 overflow-y-auto flex flex-col-reverse">
            <div
                id="scrollableDiv"
                style={{
                    height: window.innerHeight - 200,
                    overflow: "auto",
                    display: "flex",
                    flexDirection: "column-reverse"
                }}
            >
                <InfiniteScroll
                    dataLength={messages.length}
                    next={fetchMore}
                    hasMore={hasMore}
                    loader={<h4>Loading...</h4>}
                    inverse={true}
                    style={{ display: "flex", flexDirection: "column-reverse" }}
                    scrollableTarget="scrollableDiv"
                    initialScrollY={100}
                >
                    <ul className="space-y-2">
                        {messages
                            .slice()
                            .sort((a, b) => a.timestamp - b.timestamp)
                            .map((message, index) => {
                                const {
                                    message: lastMessage,
                                    id,
                                    sender,
                                } = message || {};

                                const justify =
                                    sender.email !== email ? "start" : "end";

                                return (
                                    <Message
                                        key={id + lastMessage + index}
                                        justify={justify}
                                        message={lastMessage}
                                    />
                                );
                            })}
                    </ul>
                </InfiniteScroll>
            </div>
        </div>
    );
}
